const I18N_SUFFIX = '-i18n'

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * Resolves `<key>-i18n` siblings on an svc-lab payload. svc-lab's translation
 * pipeline populates the sibling with the localised value matching the request's
 * Accept-Language; we override the base key with it and strip the sibling.
 * Falls through to the English base when the sibling is missing or empty.
 *
 * Returns `unknown` — callers must run the relevant runtime validator to narrow.
 */
export function resolveI18nFields(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(resolveI18nFields)
  }
  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {}
    for (const key of Object.keys(value)) {
      if (key.endsWith(I18N_SUFFIX)) continue
      const sibling = value[`${key}${I18N_SUFFIX}`]
      if (typeof sibling === 'string' && sibling.length > 0) {
        out[key] = sibling
      } else if (
        Array.isArray(sibling) &&
        sibling.length > 0 &&
        sibling.every((s) => typeof s === 'string' && s.length > 0)
      ) {
        out[key] = sibling
      } else {
        out[key] = resolveI18nFields(value[key])
      }
    }
    return out
  }
  return value
}
